import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, IconButton, Tooltip } from "@mui/joy";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAuth } from "../../contexts/controllers/useAuth";
import { iconCtaSxOnDark } from "../../theme";

const LogoutBox: React.FC = () => {
  const { logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  if (!isAuthenticated) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: "16px",
        left: "16px",
        zIndex: 1000,
        backgroundColor: "neutral.900",
        borderRadius: "50%",
        boxShadow: "md",
        padding: "8px",
      }}
    >
      <Tooltip title="Logout" placement="right">
        <IconButton onClick={handleLogout} color="danger" sx={iconCtaSxOnDark}>
          <LogoutIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default LogoutBox;
